import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import { getYesAndNoOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export interface DisplayBudgetSegmentedControlProps {
  name: string;
  id: string;
}

export function DisplayBudgetSegmentedControl({
  name,
  id,
}: DisplayBudgetSegmentedControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookSegmentedControlWrapper
      width="100%"
      id={id}
      control={control}
      label="Show meal credit balance?"
      name={name}
      defaultValue="Yes"
      options={getYesAndNoOptions(id)}
    />
  );
}
